<template lang="pug">
ClientOnly
    .sticky.top-0.left-0.z-10.flex.h-full(
        :class="{\
            'rightbar': !coreStore.rsidebarSmValue, \
            'rightbar-md': coreStore.rsidebarSmValue\
        }"        
    )
        .sticky.top-0.left-0.z-10.flex.flex-1.flex-col.overflow-y-auto.h-full
            .flex.flex-grow.flex-col.sticky.z-5(
                class="transition duration-1000 ease-in-out transform-gpu slide-in-from-left"
            )
                slot

            .sticky.bottom-0.left-0.z-10
                .flex.flex-1.py-2.px-2.justify-end(
                    :class="{'justify-center': !coreStore.rsidebarSmValue}"
                )
                    .flex.items-center.justify-end.flex-1
                        UButton.text-neutral-400.text-sm.font-normal(
                            v-if="coreStore.rsidebarSmValue"
                            size="md"
                            variant="link"
                            color="neutral"
                            label="Collapse"
                            icon="heroicons:chevron-double-right-20-solid"
                            @click="coreStore.rsidebarSm = !coreStore.rsidebarSmValue"
                        )
                        UButton.text-neutral-400(
                            v-else
                            size="md"
                            block
                            color="neutral"
                            variant="ghost"
                            icon="heroicons:chevron-double-left-20-solid"
                            @click="coreStore.rsidebarSm = !coreStore.rsidebarSmValue"
                        )

</template>
<script setup lang="ts">
import { DefaultSidebar } from "#components";
const coreStore = useTemplateStore()
const router = useRouter()

router.beforeEach((to, from, next) => {
    next()
})
</script>